import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser, login, logout } from "../../reducers/userSlice";
import { useForm } from "../../hooks/useForm";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { buscarVecinoRut, crearVecino, editarVecino } from "../../utils/Datos";
import { parse, format } from "date-fns";
import { Calles } from "../Otros/Calles";
import { Comunas } from "../Otros/Comunas";
import { LoadingSpinner } from "../Otros/LoadingSpinner";
import { useLocation } from "react-router-dom";

export const FormularioPerfil = ({ modo = "editar_perfil" ,neighbour_id=null}) => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
 
  const [noEsVecino, setNoEsVecino] = useState(false);
  const handleNoEsVecino = (event) => {
    if (event.target.checked) {
      //no es vecino de peñalolén
      setNoEsVecino(true);
    } else {
      //es vecino de peñalolén
      setNoEsVecino(false);
      updateState([
      {
        name: "comuna",
        value: 13122, // Peñalolén
      },
    ]);
    }
  };
  const [validado, setValidado] = useState(false);
  const [cargando, setcargando] = useState(false);
  const [existeVecino, setexisteVecino] = useState(null);

  const validarVecino = () => {
    console.log("Noesvecino ", noEsVecino);
    return noEsVecino;
  };

  const transformarFecha = (fechaString) => {
    if (fechaString === "") {
      return "";
    }
    // Parsea la fecha en formato "1900-01-01T00:00:00"
    const fecha = new Date(fechaString);
    // Formatea la fecha en el formato deseado "yyyy-MM-dd"
    const fechaFormateada = format(fecha, "yyyy-MM-dd");
    return fechaFormateada;
  };

  const transformarFechaInversa = (fechaString) => {
    if (fechaString === "") {
      return "";
    }
    // Parsea la fecha en formato "yyyy-MM-dd"
    const fecha = parse(fechaString, "yyyy-MM-dd", new Date());
    // Formatea la fecha en el formato deseado "1900-01-01T00:00:00"
    const fechaFormateada = format(fecha, "yyyy-MM-dd'T'HH:mm:ss");
    return fechaFormateada;
  };

  const [
    formulario,
    handleInputChange,
    resetForm,
    updateValue,
    updateState,
    formValuesErrores,
    validarCampos,
    formValido,
    updateStateErrores,
  ] = useForm(
    {
      rut: user.user.run.toString().trim(),
      nombres: "",
      primer_apellido: "",
      segundo_apellido: "",
      fecha_nacimiento: "",
      genero: "",
      email: "",
      fono_fijo: "",
      fono_celular: "",
      calle: "",
      comuna: "",
      macro_sector: "1",
      numero: "",
      block: "",
      depto: "",
    },
    {
      rut: {
        validaciones: [{ tipo: "vacio", mensaje: "Debe ingresar el un rut" }],
      },
      nombres: {
        validaciones: [{ tipo: "vacio", mensaje: "Debe ingresar sus nombres" }],
      },
      primer_apellido: {
        validaciones: [
          { tipo: "vacio", mensaje: "Debe ingresar su primer apellido" },
        ],
      },
      segundo_apellido: {
        validaciones: [
          { tipo: "vacio", mensaje: "Debe ingresar su segundo apellido" },
        ],
      },
      fecha_nacimiento: {
        validaciones: [
          { tipo: "vacio", mensaje: "Debe ingresar su fecha de nacimiento" },
        ],
      },
      genero: {
        validaciones: [
          { tipo: "vacio", mensaje: "Debe seleccionar una opción" },
        ],
      },
      email: {
        validaciones: [{ tipo: "vacio", mensaje: "Debe ingresar su e-mail" }],
      },
      numero: {
        validaciones: [
          { tipo: "vacio", mensaje: "Debe ingresar el número de su domicilio" },
        ],
      },
      calle: {
        validaciones: [{ tipo: "vacio", mensaje: "Debe ingresar una calle" }],
      },
      macro_sector: {
        activo: !noEsVecino,
        validaciones: [
          {
            tipo: "vacio",
            mensaje: "Debe seleccionar un macro sector",
          },
        ],
      },
      comuna: {
        activo: noEsVecino,
        validaciones: [
          {
            tipo: "vacio",
            mensaje: "Debe seleccionar una comuna",
          },
        ],
      },
    }
  );

  useEffect(() => {
    if (user !== null) {
      updateState([
        {
          name: "rut",
          value: user.user.run ?? "",
        },
        {
          name: "nombres",
          value: user.user.name ?? "",
        },
        {
          name: "primer_apellido",
          value: user.user.lastname ?? "",
        },
      ]);
      //updateValue("nombres",user.user.name);
      //updateValue("primer_apellido",user.user.lastname);
      buscarVecinoRut(user.user.run).then((vecino) => {
        if (vecino.status) {
          console.log("vecino", vecino);
          setexisteVecino(vecino.datos);
          const { datos } = vecino;
          updateState([
            {
              name: "nombres",
              value: datos.name ?? "",
            },
            {
              name: "primer_apellido",
              value: datos.last_name ?? "",
            },
            {
              name: "segundo_apellido",
              value: datos.last_name2 ?? "",
            },

            {
              name: "fecha_nacimiento",
              value: transformarFecha(datos.birth_date) ?? "",
            },
            {
              name: "genero",
              value: datos.sex ?? "",
            },
            {
              name: "email",
              value: datos.email ?? "",
            },
            {
              name: "fono_fijo",
              value: datos.phone_contact ?? "",
            },
            {
              name: "fono_celular",
              value: datos.phone_movil ?? "",
            },
            {
              name: "calle",
              value: datos.neighbor_address.street ?? "",
            },
            {
              name: "block",
              value: datos.neighbor_address.block ?? "",
            },
            {
              name: "depto",
              value: datos.neighbor_address.dept ?? "",
            },
            {
              name: "numero",
              value: datos.neighbor_address.number ?? "",
            },
            {
              name: "comuna",
              value: datos.neighbor_address.commune_id,
            },
            {
              name: "macro_sector",
              value: datos.neighbor_address.macroSector_id ?? "",
            },
            /* calle: "",
            comuna: "",
            macro_sector: "",
            */
          ]);

          if (datos.neighbor_address.commune_id != 13122) {
            setNoEsVecino(true); 
          }
        } else {
          console.log("no existe vecino");
        }
      });
    }
  }, [user]);

  useEffect(() => {
    if (validado) validarCampos();
  }, [formulario]);

  useEffect(() => {
    if (noEsVecino) {
      updateStateErrores([
        {
          name: "comuna",
          value: { activo: true },
        },
        {
          name: "macro_sector",
          value: { activo: false },
        },
      ]);
    } else {
      updateStateErrores([
        {
          name: "comuna",
          value: { activo: false },
        },
        {
          name: "macro_sector",
          value: { activo: true },
        },
      ]);
    }
  }, [noEsVecino]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const handleContinuar = async () => {
    const valido = await validarCampos();
    setValidado(true);
    if (valido) {
      //CREAR PAYLOAD EXTREMO CON LOS DATOS DEL FORMULARIO
      let payload = {
        identifier_number: formulario.rut.split("-")[0],
        identifier_dv: formulario.rut.split("-")[1],
        name: formulario.nombres,
        last_name: formulario.primer_apellido,
        last_name2: formulario.segundo_apellido,
        birth_date: transformarFechaInversa(formulario.fecha_nacimiento),
        sex: formulario.genero,
        email: formulario.email,
        phone_contact: formulario.fono_fijo,
        phone_movil: formulario.fono_celular,
        marital_status: 1,
        nationality: "CHILENA",
        handicapped_condition: false,
        indigenous_condition: false,
        status_active: false,
        record_form: "oirs_digital",
        neighbor_address: {
          street: formulario.calle,
          number: formulario.numero,
          block: formulario.block,
          dept: formulario.depto,
          macroSector_id: formulario.macro_sector,
          commune_id: formulario.comuna,
          normalized: true,
        },
      };

      setcargando(true);
      if (modo === "primer_registro") {
        crearVecino(payload).then((respuesta) => {
          setcargando(false);
          if (respuesta.status) {

            let userOirsPena = JSON.parse(localStorage.getItem('userOirsPena'));
            userOirsPena.user.user.perfil_completo = "1";
            localStorage.setItem('userOirsPena', JSON.stringify(userOirsPena));

            dispatch(login({
              user: {
                ...user.user,
                perfil_completo: "1",
                actualizado: 1,
                // actualiza los campos necesarios
              },
              loggedIn: true,
            }));

            navigate("/home");
          } else {
            Swal.fire({
              icon: "warning",
              title: "Atención",
              text: respuesta.errores,
            });
          }
        });
      }else{
        payload["neighbour_id"]=neighbour_id;
        payload["modify_by"]="VEC";
        editarVecino(payload).then((respuesta) => {
          setcargando(false);
          if (respuesta.status) {

            Swal.fire({
              icon:'success',
              title:'Correcto',
              text:'Datos actualizados con éxito'
            })
            navigate("/home");
          } else {
            Swal.fire({
              icon: "warning",
              title: "Atención",
              text: respuesta.errores,
            });
          }
        });
      }

      //console.log("el formulario",payload);
      //guardar al vecino
      //navigate("/home");
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "El formulario contiene errores",
      });
    }
  };

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const causa = query.get("causa") ?? null;

  useEffect(() => {
    if (causa) {
      console.log("Causa:", causa);
    }
  }, [causa]);

  return !cargando ? (
    <>
      <div className="row mb-5">
        <div className="col-lg-12">
          { causa === "datos-incompletos" ?
           <div  className="alert alert-info">
              Para continuar por favor primero complete su informacón
          </div> : <></>
          }
        </div>
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-4 fv-row fv-plugins-icon-container">
              <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                RUT
              </label>
              <input
                type="text"
                name="rut"
                className="form-control form-control-lg   mb-3 mb-lg-0"
                readOnly
                placeholder="RUT"
                value={formulario.rut}
                onChange={() => {
                  console.log("do nothing");
                }}
              />
              {formValuesErrores.rut.error}

              <a href="#" onClick={handleLogout}>
                <small>Este no es mi RUT</small>
              </a>
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-4 fv-row fv-plugins-icon-container ">
              <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                Nombres
              </label>
              <input
                type="text"
                name="nombres"
                className="form-control form-control-lg   mb-3 mb-lg-0"
                placeholder="Nombres"
                value={formulario.nombres}
                onChange={handleInputChange}
              />
              {formValuesErrores.nombres.error}
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>

            <div className="col-lg-4 fv-row fv-plugins-icon-container ">
              <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                Primer apellido
              </label>
              <input
                type="text"
                name="primer_apellido"
                className="form-control form-control-lg  "
                placeholder="Primer Apellido"
                value={formulario.primer_apellido}
                onChange={handleInputChange}
              />
              {formValuesErrores.primer_apellido.error}
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>

            <div className="col-lg-4 fv-row fv-plugins-icon-container ">
              <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                Segundo apellido
              </label>
              <input
                type="text"
                name="segundo_apellido"
                className="form-control form-control-lg  "
                placeholder="Segundo Apellido"
                value={formulario.segundo_apellido}
                onChange={handleInputChange}
              />
              {formValuesErrores.segundo_apellido.error}
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-4 fv-row fv-plugins-icon-container">
              <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                Fecha de nacimiento
              </label>
              <input
                type="date"
                name="fecha_nacimiento"
                className="form-control form-control-lg   mb-3 mb-lg-0"
                value={formulario.fecha_nacimiento}
                onChange={handleInputChange}
              />
              {formValuesErrores.fecha_nacimiento.error}
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>

            <div className="col-lg-4 fv-row fv-plugins-icon-container">
              <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                Género
              </label>
              <select
                type="text"
                name="genero"
                className="form-control form-control-lg  "
                value={formulario.genero}
                onChange={handleInputChange}
              >
                <option value="">-Seleccione una opción-</option>
                <option value="Mujer">Mujer</option>
                <option value="Hombre">Hombre</option>
                <option value="Prefiero no decirlo">Prefiero no decirlo</option>
                <option value="Otros">Otros</option>
              </select>
              {formValuesErrores.genero.error}
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-4 fv-row fv-plugins-icon-container ">
              <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                E-mail
              </label>
              <input
                type="email"
                name="email"
                className="form-control form-control-lg   mb-3 mb-lg-0"
                placeholder="E-mail"
                value={formulario.email}
                onChange={handleInputChange}
              />
              {formValuesErrores.email.error}
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>

            <div className="col-lg-4 fv-row fv-plugins-icon-container">
              <label className="mb-3 fw-semibold fs-6">Fono Fijo</label>
              <input
                type="text"
                name="fono_fijo"
                className="form-control form-control-lg  "
                placeholder="Fono Fijo"
                value={formulario.fono_fijo}
                onChange={handleInputChange}
              />
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>

            <div className="col-lg-4 fv-row fv-plugins-icon-container">
              <label className="mb-3 fw-semibold fs-6">Fono Celular</label>
              <input
                type="text"
                name="fono_celular"
                className="form-control form-control-lg  "
                placeholder="Fono Celular"
                value={formulario.fono_celular}
                onChange={handleInputChange}
              />
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-5 mt-5">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-4 fv-row fv-plugins-icon-container">
              <label className="form-check form-check-custom form-check-inline form-check-solid">
                <input
                  checked={noEsVecino}
                  onChange={handleNoEsVecino}
                  className="form-check-input"
                  name="vecino"
                  type="checkbox"
                  value="es_vecino"
                />
                <span className="fw-semibold ps-2 fs-6">
                  No soy vecino de Peñalolén
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {!noEsVecino ? (
        <div className="row mb-5">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-4 fv-row fv-plugins-icon-container">
                <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                  Calle
                </label>
                {/*}
                <select
                  type="text"
                  className="form-control form-control-lg  "
                  name="calle"
                  value={formulario.calle}
                  onChange={handleInputChange}
                >
                  <option value="">-Seleccione una opción-</option>
                  <option value="calle1">calle1</option>
                  <option value="calle2">calle2</option>
                  <option value="calle3">calle3</option>
                </select>
                { */}
                <Calles updateState={updateState} val={formulario.calle} />
                {formValuesErrores.calle.error}
                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
              </div>
              <div className="col-lg-4 fv-row fv-plugins-icon-container">
                <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                  Macrosector
                </label>
                <select
                  type="text"
                  className="form-control form-control-lg  "
                  name="macro_sector"
                  value={formulario.macro_sector}
                  onChange={handleInputChange}
                >
                  <option value="1">-Seleccione una opción-</option>
                  <option value="3">Lo Hermida</option>
                  <option value="9">San Luis</option>
                  <option value="2">La Faena</option>
                  <option value="5">Peñalolén Alto</option>
                  <option value="4">Peñalolén Nuevo</option>
                </select>
                {formValuesErrores.macro_sector.error}
                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="row mb-5">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-4 fv-row fv-plugins-icon-container">
                <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                  Calle
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg  "
                  name="calle"
                  value={formulario.calle}
                  onChange={handleInputChange}
                />
                {formValuesErrores.calle.error}
                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
              </div>
              <div className="col-lg-4 fv-row fv-plugins-icon-container">
                <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                  Comuna
                </label>
                {/*}
                <select
                  type="text"
                  className="form-control form-control-lg  "
                  name="comuna"
                  value={formulario.comuna}
                  onChange={handleInputChange}
                >
                  <option value="">-Seleccione una opción-</option>
                  <option value="13122">Las comunas</option>
                </select> */}
                <Comunas updateState={updateState} val={formulario.comuna} />
                {formValuesErrores.comuna.error}
                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="row mb-5">
        <div className="col-lg-6">
          <div className="row">
            <div className="col-lg-4 fv-row fv-plugins-icon-container">
              <label className="form-label fs-6 fw-bold text-gray-700 mb-3 required">
                Número
              </label>
              <input
                type="text"
                name="numero"
                className="form-control form-control-lg   mb-3 mb-lg-0"
                placeholder="Número"
                value={formulario.numero}
                onChange={handleInputChange}
              />
              {formValuesErrores.numero.error}
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>

            <div className="col-lg-4 fv-row fv-plugins-icon-container">
              <label className="mb-3 fw-semibold fs-6">Block / casa</label>
              <input
                type="text"
                name="block"
                className="form-control form-control-lg  "
                placeholder="Block / casa"
                value={formulario.block}
                onChange={handleInputChange}
              />
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>

            <div className="col-lg-4 fv-row fv-plugins-icon-container">
              <label className="mb-3  fw-semibold fs-6">Depto</label>
              <input
                type="text"
                name="depto"
                className="form-control form-control-lg  "
                placeholder="depto"
                value={formulario.depto}
                onChange={handleInputChange}
              />
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" />
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-5 mt-8">
        <div className="col-md-12 text-right">
          <button
            onClick={handleContinuar}
            className="btn btn-success"
            data-cu="VEC_CU1"
          >
            <i className="fas fa-arrow-right"></i>Continuar
          </button>
        </div>
      </div>
    </>
  ) : (
    <>
      <LoadingSpinner texto={"Enviando datos, espere un momento..."} />
    </>
  );
};
